export default "__VITE_ASSET__BadQTI61__"